import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import {
  ProductSummaryBlockDefinition,
  ProductSummaryMetadata,
} from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import type { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';

import { useFieldNotInThisVersion } from './hooks';
import { componentForTypeAndId } from './ProductSummaryBuilder.helper';

interface ProductSummaryBuilderProps {
  rootNodes: ProductSummaryMetadata;
  tabId: string;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
}

export const ProductSummaryBuilder: FC<ProductSummaryBuilderProps> = ({
  tabId,
  rootNodes,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  return (
    <>
      {rootNodes.properties.map(node => {
        return (
          <ProductSummaryNode
            tabId={tabId}
            node={node}
            level={1}
            key={node.id}
            quoteWorkspaceVersion={quoteWorkspaceVersion}
            batchWorkspaceVersion={batchWorkspaceVersion}
            mustForceAdvancedMode={mustForceAdvancedMode}
          />
        );
      })}
    </>
  );
};

export interface ProductSummaryNodeProps {
  tabId: string;
  node: ProductSummaryBlockDefinition | ReadonlyValueDefinition;
  level: number;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
}
export const ProductSummaryNode: FC<ProductSummaryNodeProps> = ({
  tabId,
  node,
  level,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  const NodeComponent = componentForTypeAndId({
    tabId,
    node,
    level,
    quoteWorkspaceVersion,
    batchWorkspaceVersion,
    mustForceAdvancedMode,
  });
  const isHidden = node.isHidden;
  const isNotInThisVersion = useFieldNotInThisVersion(node, quoteWorkspaceVersion, mustForceAdvancedMode);

  if (isHidden || isNotInThisVersion) {
    return null;
  }

  return (
    <GenericErrorBoundary key={`poor-man-error-boundary-form-builder-${node.id}`}>{NodeComponent}</GenericErrorBoundary>
  );
};

ProductSummaryBuilder.displayName = 'ProductSummaryBuilder';
